import { Controller, useForm } from 'react-hook-form';
import PhoneNumberInput from '../../../../components-library/PhoneNumberInput';
import { LoginSchema, loginSchema } from './schema';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../store/types';
import { REDUX_STORE_SLICES } from '../../../../services/exports/Constants';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '../../components/buttons/Button';
import { useTranslation } from 'react-i18next';
import { PropsWithChildren } from 'react';
import { toast } from 'react-hot-toast';

interface LoginFormProps extends PropsWithChildren {
  onSubmit: (data: LoginSchema) => void;
  loading: boolean;
}

const LoginForm = ({ onSubmit, loading, children }: LoginFormProps) => {
  const companyId = useSelector((state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company.id);
  const form = useForm<LoginSchema>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      phone_number: '',
      company_id: companyId,
    },
  });
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:Login:LoginForm' });

  const _onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (!form.getValues().phone_number) {
      toast.error(t('feedback.phone_number_required'));
    }
    form.handleSubmit(onSubmit)(e);
  };

  return (
    <>
      <form className="space-y-4 text-center" onSubmit={_onSubmit}>
        <div>
          <Controller
            name="phone_number"
            control={form.control}
            render={({ field: { ref: _ref, ...rest }, fieldState }) => (
              <PhoneNumberInput
                placeholder={t('placeholders.mobile_number')}
                {...rest}
                validationErrors={fieldState?.error?.message ? [fieldState.error?.message] : []}
              />
            )}
          />
        </div>
        {children && children}
        <Button
          title={t('buttons.send_code')}
          type="submit"
          expand="block"
          loading={loading}
          className="[&::part(native)]:-ml-[2px]"
        />
      </form>
    </>
  );
};

export default LoginForm;
